<section class="section section-square-pattern">
  <div class="container">
    <app-error-status
      [header]="'Oeps! Hier ging iets mis.'"
      [description]="'Je bent op een pagina die er even niet is.'"
      [imageResource]="'/assets/images/errors/tmo_error_oeps.png'"
    ></app-error-status>
  </div>
</section>
